import { cn } from '@/lib/utils';

export interface FluxterMarkProps {
  className?: string;
  /** stroke width relative to the 33-unit viewBox; default tuned for 16px renders */
  strokeWidth?: number;
}

/**
 * The X-shaped mark from the Fluxter logo, recolored to the brand accent token.
 * Pure strokes — scales cleanly from 14px (header dot) to 64px (loading splash)
 * without rasterizing.
 */
export const FluxterMark = ({ className, strokeWidth = 2.5 }: FluxterMarkProps) => (
  <svg
    viewBox="0 0 33 34"
    fill="none"
    stroke="var(--brand-accent)"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    aria-hidden="true"
    className={cn('inline-block', className)}
  >
    <path d="M2.812 3.351 16.452 16.991" />
    <path d="M30.091 3.351 16.452 16.991" />
    <path d="M2.812 30.631 16.452 16.991" />
    <path d="M30.091 30.631 16.452 16.991" />
    <path d="M9.092 2.812 16.452 10.171 23.794 2.812" />
    <path d="M30.091 10.171 23.272 16.991 30.091 23.811" />
    <path d="M9.092 31.17 16.452 23.811 23.794 31.153" />
    <path d="M2.812 10.171 9.632 16.991 2.812 23.811" />
  </svg>
);
